import Grid from "@mui/material/Grid";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Box, FormField, Modal } from "@maysoft/common-component-react";

import Helpers from "commons/helpers";
import Strings from "constants/strings";
import ProjectService from "services/medkit/project.service";

import { setDataAlert, showLoading } from "store/slice/common.slice";



const projectService = new ProjectService();

const ModalCreateUpdateProject = ({
    visible,
    projectId,
    setVisible,
    onCallBack,
}: {
    visible: boolean;
    projectId: string;
    onCallBack: () => void;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}) => {

    const dispatch = useDispatch();
    const [errorDetail, setErrorDetail] = useState<{
        name?: string;
        description?: string;
    }>({});
    const [projectDetail, setProjectDetail] = useState<{
        id?: string;
        name?: string;
        description?: string;
    }>({});

    useEffect(() => {
        if (!Helpers.isNullOrEmpty(projectId) && visible) {
            (async () => {
                try {
                    dispatch(showLoading(true));

                    const result = await projectService.getDetail(projectId);

                    setErrorDetail({});
                    setProjectDetail({
                        id: result.id,
                        name: result.name,
                        description: result.description,
                    });

                } catch (error) {
                    const err = Helpers.handleExceptionError(error);
                    !Helpers.isNullOrEmpty(err) && dispatch(setDataAlert({ message: err, type: "error" }));
                } finally {
                    dispatch(showLoading(false));
                }
            })();
        }
    }, [visible, projectId]);

    const handleCloes = () => {
        setVisible(false);
        setErrorDetail({});
        setProjectDetail({});
    };

    const handleSubmit = async () => {
        if (Helpers.isNullOrEmpty(projectDetail?.name)) {
            setErrorDetail((prev) => ({
                ...prev,
                name: Strings.PROJECT_MANAGEMENT.PLEASE_ENTER_PROJECT_NAME,
            }));
        } else {
            try {
                dispatch(showLoading(true));

                let msg = "";

                if (Helpers.isNullOrEmpty(projectDetail?.id)) {
                    await projectService.create({
                        name: projectDetail?.name,
                        description: projectDetail?.description,
                    });

                    msg = Strings.PROJECT_MANAGEMENT.CREATE_PROJECT_SUCCESS;
                } else {
                    await projectService.update({
                        id: projectDetail?.id,
                        name: projectDetail?.name,
                        description: projectDetail?.description,
                    });

                    msg = Strings.PROJECT_MANAGEMENT.UPDATE_PROJECT_SUCCESS;
                }

                dispatch(setDataAlert({ message: msg, type: "success" }));

                onCallBack();
            } catch (error) {
                const err = Helpers.handleExceptionError(error);
                !Helpers.isNullOrEmpty(err) && dispatch(setDataAlert({ message: err, type: "error" }));
            } finally {
                dispatch(showLoading(false));
                handleCloes();
            }
        }
    };

    return (
        <Modal
            fullWidth
            hasActionButton
            maxWidth={"sm"}
            visible={visible}
            onClose={() => { handleCloes(); }}
            onAction={() => { handleSubmit(); }}
            title={Helpers.isNullOrEmpty(projectDetail?.id) ? Strings.COMMON.ADD_NEW : Strings.COMMON.EDIT}
        >
            <Box padding={"24px 16px"}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <FormField
                            required
                            variant={"outlined"}
                            value={projectDetail?.name || ""}
                            errorMessage={errorDetail?.name || ""}
                            label={Strings.PROJECT_MANAGEMENT.PROJECT_NAME}
                            placeholder={Strings.PROJECT_MANAGEMENT.ENTER_PROJECT_NAME}
                            onChangeValue={(value) => {
                                setErrorDetail(prev => ({
                                    ...prev,
                                    name: undefined,
                                }));
                                setProjectDetail(prev => ({
                                    ...prev,
                                    name: value,
                                }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            variant={"outlined"}
                            value={projectDetail?.description || ""}
                            errorMessage={errorDetail?.description || ""}
                            label={Strings.PROJECT_MANAGEMENT.DESCRIPTION}
                            placeholder={Strings.PROJECT_MANAGEMENT.ENTER_DESCRIPTION}
                            onChangeValue={(value) => {
                                setErrorDetail(prev => ({
                                    ...prev,
                                    description: undefined,
                                }));
                                setProjectDetail(prev => ({
                                    ...prev,
                                    description: value,
                                }));
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    );
}

export default ModalCreateUpdateProject;